import SignupV2HowItWorks from './SignupV2HowItWorks';

export default SignupV2HowItWorks;
